import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  activeList: null,
  finishedList: null,
  canViewStats: false,
  sessionTypes: [],
  participants: [],
  specificTrainingData: null,
  activityData: null,
  resolutionData: null,
  questionData: null,
  trainingStats: [],
  participantStats: [],
  specificTrainingStats: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_ALL:
      return initialState;

    case actionTypes.GET_ALL_MY_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.GET_ALL_MY_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activeList: action.payload.activeList,
        finishedList: action.payload.finishedList,
        sessionTypes: action.payload.sessionTypes,
        canViewStats: action.payload.canViewStats,
      };
    case actionTypes.GET_ALL_MY_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES:
      return { ...state, isLoading: true };
    case actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.DOWNLOAD_MY_TRAINING_CERTIFICATES_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_SPECIFIC_TRAINING_PROGRESS:
      return { ...state, isLoading: true };
    case actionTypes.GET_SPECIFIC_TRAINING_PROGRESS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        participants: action.payload.participants,
      };
    case actionTypes.GET_SPECIFIC_TRAINING_PROGRESS_REJECTED:
      return { ...state, isLoading: false };

    ////////////////////////////////////// execution
    case actionTypes.GET_SPECIFIC_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.GET_SPECIFIC_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        specificTrainingData: action.payload.specificTrainingData,
      };
    case actionTypes.GET_SPECIFIC_TRAINING_REJECTED:
      return { ...state, isLoading: false };
    case actionTypes.RESET_SPECIFIC_TRAINING:
      return { ...state, specificTrainingData: null };

    case actionTypes.GET_ACTIVITY:
      return { ...state, isLoading: true };
    case actionTypes.GET_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.GET_ACTIVITY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.ANSWER_ACTIVITY:
      return { ...state, isLoading: true };
    case actionTypes.ANSWER_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.ANSWER_ACTIVITY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.START_ACTIVITY:
      return { ...state, isLoading: true };
    case actionTypes.START_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.START_ACTIVITY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_COUNTDOWN_ACTIVITY:
      return { ...state };
    case actionTypes.GET_COUNTDOWN_ACTIVITY_FULFILLED:
      return {
        ...state,
        activityData: { ...state.activityData, countdown: action.payload.countdown },
      };
    case actionTypes.GET_COUNTDOWN_ACTIVITY_REJECTED:
      return { ...state };

    case actionTypes.GET_RESOLUTION:
      return { ...state, isLoading: true };
    case actionTypes.GET_RESOLUTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        resolutionData: action.payload.resolutionData,
      };
    case actionTypes.GET_RESOLUTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GRADE_ACTIVITY:
      return { ...state, isLoading: true };
    case actionTypes.GRADE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.GRADE_ACTIVITY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_ACTIVITY_ATTEMPT:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_ACTIVITY_ATTEMPT_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.UPDATE_ACTIVITY_ATTEMPT_REJECTED:
      return { ...state, isLoading: false };

    ////////////////////////////////////// q&a
    case actionTypes.VOTE_QUESTION:
      return { ...state, isLoading: true };
    case actionTypes.VOTE_QUESTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.VOTE_QUESTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CLOSE_QUESTION:
      return { ...state, isLoading: true };
    case actionTypes.CLOSE_QUESTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.CLOSE_QUESTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_QUESTION_AND_ANSWERS:
      return { ...state, isLoading: true };
    case actionTypes.GET_QUESTION_AND_ANSWERS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        questionData: action.payload.questionData,
      };
    case actionTypes.GET_QUESTION_AND_ANSWERS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_QUESTION:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_QUESTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.CREATE_QUESTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_QUESTION:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_QUESTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.UPDATE_QUESTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_QUESTION:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_QUESTION_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.DELETE_QUESTION_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_ANSWER:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_ANSWER_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
        questionData: action.payload.questionData,
      };
    case actionTypes.CREATE_ANSWER_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_ANSWER:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_ANSWER_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
        questionData: action.payload.questionData,
      };
    case actionTypes.UPDATE_ANSWER_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_ANSWER:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_ANSWER_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
        questionData: action.payload.questionData,
      };
    case actionTypes.DELETE_ANSWER_REJECTED:
      return { ...state, isLoading: false };

    ////////////////////////////////////// notes
    case actionTypes.UPDATE_NOTE:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_NOTE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        activityData: action.payload.activityData,
        specificTrainingData: { ...state.specificTrainingData, modules: action.payload.modules },
      };
    case actionTypes.UPDATE_NOTE_REJECTED:
      return { ...state, isLoading: false };

    ////////////////////////////////////// stats
    case actionTypes.GET_STATS:
      return { ...state, isLoading: true };
    case actionTypes.GET_STATS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        trainingStats: action.payload.trainingStats,
        participantStats: action.payload.participantStats,
      };
    case actionTypes.GET_STATS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_STATS_BY_TRAINING:
      return { ...state, isLoading: true };
    case actionTypes.GET_STATS_BY_TRAINING_FULFILLED:
      return {
        ...state,
        isLoading: false,
        specificTrainingStats: action.payload.specificTrainingStats,
      };
    case actionTypes.GET_STATS_BY_TRAINING_REJECTED:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
